import { ChevronsUpDown } from "lucide-react";
import React, { ReactNode } from "react";

import { IgAutocomplete, IgTypography } from "@intelligems/ig-theme";
import { AutocompleteProps, Box, useTheme } from "@mui/material";
import { ChipTypeMap } from "@mui/material/Chip";
import {
  ListboxComponent,
  StyledPopper,
} from "@src/components/VirtualAutoComplete/List";

export const VirtualAutoComplete = <
  Value,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
  ChipComponent extends React.ElementType = ChipTypeMap["defaultComponent"],
>(
  props: AutocompleteProps<
    Value,
    Multiple,
    DisableClearable,
    FreeSolo,
    ChipComponent
  > & { formatter: (data: Value) => ReactNode; label?: string }
) => {
  const { formatter, ...rest } = props;
  const theme = useTheme();
  return (
    <Box>
      {props.label ? (
        <span>
          <IgTypography>{props.label}</IgTypography>
        </span>
      ) : null}
      <IgAutocomplete
        {...rest}
        disableListWrap
        PopperComponent={StyledPopper}
        ListboxComponent={ListboxComponent}
        renderOption={(props, option, state) =>
          [props, formatter(option), state.index] as any
        }
        popupIcon={<ChevronsUpDown size={16} />}
        renderGroup={(params) => params as any}
      />
    </Box>
  );
};
